import React, { createContext, useContext, useState, useEffect } from 'react';
import { userService } from '../services/userService';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchAuthUser = async () => {
      const token = localStorage.getItem('token');
      
      // Si pas de token, pas besoin d'appeler l'API
      if (!token) {
        setLoading(false);
        return;
      }
      
      try {
        const response = await userService.getAuthUser();
        setUser(response.admin);
      } catch (error) {
        console.error('Erreur lors de la récupération de l\'utilisateur', error);
        // En cas d'erreur, on s'assure que l'utilisateur est déconnecté
        setUser(null);
        localStorage.removeItem('token');
      } finally {
        setLoading(false);
      }
    };
    
    fetchAuthUser();
  }, []);
  
  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};